import { FC, ReactNode } from "react";
import { HomeToolbarContainer, HomeToolbarInner } from "./homeToolbar.styles";

interface CustomButtonProps {
    children: ReactNode;
}
  
const HomeToolbar: FC<CustomButtonProps> = ({ children }) => (
    <HomeToolbarContainer>
      <HomeToolbarInner>
          {children}
      </HomeToolbarInner>
    </HomeToolbarContainer>
);

  
export default HomeToolbar;
  